import { render, staticRenderFns } from "./StokSecButon.vue?vue&type=template&id=21acdac2"
import script from "./StokSecButon.vue?vue&type=script&lang=js"
export * from "./StokSecButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports